<template>
  <div>
    <!-- 작업유형 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업유형</h5>
      <div class="grid xl:grid-cols-6 gap-x-6 gap-y-4 mt-4">
        <div v-for="item in list" :key="`checkbox_${item.id}`" class="col-span-1 flex items-center">
          <div v-if="isPrint || readonly" class="flex items-center">
            <div v-if="item.checked" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">
              {{ item.label }}
            </span>
          </div>
          <div v-else>
            <span class="flex">
              <vs-checkbox :readonly="readonly" v-model="item.checked" @change="handleChange">{{ item.label }}</vs-checkbox>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-for="(_item, _item_i) in list" :key="`inspect_${_item.id}_${_item_i}`" v-show="_item.checked">
      <table-inspect-merge
        multi-check
        :is-print="isPrint"
        :is-readonly="readonly"
        :title="_item.label"
        :table-header-title="'점검사항'"
        :table-header-check="[{ text: '신청자' }, { text: '허가자', readonly: !postId }, { text: '연장허가', readonly: !postId }]"
        :table-header-note="[]"
        :contentBefore="'•'"
        v-model="_item.list"
        class="mt-5"
      >
        <template #customContent="{ trData }">
          <!-- PC 버전과 모바일 버전을 분리하여 처리 -->
          <div v-if="!isMobile">
            <!-- PC 버전 -->
            <!-- 일반작업 -->
            <div v-if="_item.id === 1">
              <div class="flex" style="align-items: center">
                <p style="color: #4839eb">위치:</p>
                <p v-if="isPrint">{{ trData.위치 }}</p>
                <ml-input v-else v-model="trData.위치" class="mx-2" style="width: 350px" />
              </div>
            </div>

            <!-- 화기작업 -->
            <div v-else-if="_item.id === 2">
              <div class="flex" style="align-items: center">
                <p style="color: #4839eb">성명:</p>
                <p v-if="isPrint">{{ trData.성명 }}</p>
                <ml-input v-else v-model="trData.성명" class="mx-2" />
              </div>
            </div>

            <!-- 중장비 관련 작업 -->
            <div v-else-if="_item.id === 4">
              <div class="flex" style="align-items: center">
                <p v-if="isPrint">{{ trData.투입장비 }}</p>
                <ml-input v-else v-model="trData.투입장비" class="mx-2" style="width: 310px" />
              </div>
            </div>

            <!-- 밀폐공간 작업 -->
            <div v-else-if="_item.id === 5">
              <div class="flex" style="align-items: center">
                <p v-if="isPrint">{{ trData.감시인 }}</p>
                <ml-input v-else v-model="trData.감시인" placeholder="감시인" class="mx-2" style="width: 310px" />
              </div>
            </div>

            <!-- 정전(전기차단)작업 -->
            <div v-else-if="_item.id === 6">
              <div v-if="trData.customType === '1'" class="flex" style="align-items: center">
                <p style="color: #4839eb">차단기 번호:</p>
                <p v-if="isPrint">{{ trData.차단기번호 }}</p>
                <ml-input v-else v-model="trData.차단기번호" class="mx-2" />
              </div>
              <div v-else-if="trData.customType === '2'" class="flex" style="align-items: center">
                <p style="color: #4839eb">차단자:</p>
                <p v-if="isPrint">{{ trData.차단자 }}</p>
                <ml-input v-else v-model="trData.차단자" class="mx-2" />
                <p style="color: #4839eb">차단시간:</p>
                <p v-if="isPrint">{{ trData.차단시간 }}</p>
                <time-selector v-else v-model="trData.차단시간" class="mx-2" />
              </div>
              <div v-else-if="trData.customType === '3'" class="flex" style="align-items: center">
                <p style="color: #4839eb">복구자:</p>
                <p v-if="isPrint">{{ trData.복구자 }}</p>
                <ml-input v-else v-model="trData.복구자" class="mx-2" />
                <p style="color: #4839eb">복구시간:</p>
                <p v-if="isPrint">{{ trData.복구시간 }}</p>
                <time-selector v-else v-model="trData.복구시간" class="mx-2" />
              </div>
            </div>

            <!-- 방사선 관련 작업 -->
            <div v-else-if="_item.id === 8">
              <div class="flex" style="align-items: center">
                <p v-if="isPrint">{{ trData.작업감시자 }}</p>
                <ml-input v-else v-model="trData.작업감시자" class="mx-2" style="width: 200px" />
              </div>
            </div>
          </div>

          <div v-else>
            <!-- 모바일 버전 -->
            <!-- 일반작업 -->
            <div v-if="_item.id === 1">
              <div class="flex flex-col mb-2">
                <p style="color: #4839eb; margin-bottom: 4px">위치:</p>
                <p v-if="isPrint">{{ trData.위치 }}</p>
                <ml-input v-else v-model="trData.위치" class="w-full" />
              </div>
            </div>

            <!-- 화기작업 -->
            <div v-else-if="_item.id === 2">
              <div class="flex flex-col mb-2">
                <p style="color: #4839eb; margin-bottom: 4px">성명:</p>
                <p v-if="isPrint">{{ trData.성명 }}</p>
                <ml-input v-else v-model="trData.성명" class="w-full" />
              </div>
            </div>

            <!-- 중장비 관련 작업 -->
            <div v-else-if="_item.id === 4">
              <div class="flex flex-col mb-2">
                <p style="color: #4839eb; margin-bottom: 4px">투입장비:</p>
                <p v-if="isPrint">{{ trData.투입장비 }}</p>
                <ml-input v-else v-model="trData.투입장비" class="w-full" />
              </div>
            </div>

            <!-- 밀폐공간 작업 -->
            <div v-else-if="_item.id === 5">
              <div class="flex" style="align-items: center">
                <p v-if="isPrint">{{ trData.감시인 }}</p>
                <ml-input v-else v-model="trData.감시인" placeholder="감시인" class="w-full" />
              </div>
            </div>

            <!-- 정전(전기차단)작업 -->
            <div v-else-if="_item.id === 6">
              <div v-if="trData.customType === '1'" class="flex flex-col mb-2">
                <p style="color: #4839eb; margin-bottom: 4px">차단기 번호:</p>
                <p v-if="isPrint">{{ trData.차단기번호 }}</p>
                <ml-input v-else v-model="trData.차단기번호" class="w-full" />
              </div>
              <div v-else-if="trData.customType === '2'" class="mb-2">
                <div class="flex flex-col mb-2">
                  <p style="color: #4839eb; margin-bottom: 4px">차단자:</p>
                  <p v-if="isPrint">{{ trData.차단자 }}</p>
                  <ml-input v-else v-model="trData.차단자" class="w-full" />
                </div>
                <div class="flex flex-col">
                  <p style="color: #4839eb; margin-bottom: 4px">차단시간:</p>
                  <p v-if="isPrint">{{ trData.차단시간 }}</p>
                  <time-selector v-else v-model="trData.차단시간" class="w-full" />
                </div>
              </div>
              <div v-else-if="trData.customType === '3'" class="mb-2">
                <div class="flex flex-col mb-2">
                  <p style="color: #4839eb; margin-bottom: 4px">복구자:</p>
                  <p v-if="isPrint">{{ trData.복구자 }}</p>
                  <ml-input v-else v-model="trData.복구자" class="w-full" />
                </div>
                <div class="flex flex-col">
                  <p style="color: #4839eb; margin-bottom: 4px">복구시간:</p>
                  <p v-if="isPrint">{{ trData.복구시간 }}</p>
                  <time-selector v-else v-model="trData.복구시간" class="w-full" />
                </div>
              </div>
            </div>

            <!-- 방사선 관련 작업 -->
            <div v-else-if="_item.id === 8">
              <div class="flex flex-col mb-2">
                <p style="color: #4839eb; margin-bottom: 4px">작업감시자:</p>
                <p v-if="isPrint">{{ trData.작업감시자 }}</p>
                <ml-input v-else v-model="trData.작업감시자" class="w-full" />
              </div>
            </div>
          </div>
        </template>
      </table-inspect-merge>

      <!-- 화기작업 -->
      <table-custom
        v-if="_item.id === 2"
        :board="board"
        :is-print="isPrint"
        title="가스농도 측정결과(화기작업)"
        :controls="!!postId"
        :tableData="[
          { id: '물질명', title: '물질명', type: 'fixed-text', defaultValue: 'NG', placeholder: '', readonly: !postId },
          { id: '결과', title: '결과', type: 'text', placeholder: '', afterText: 'LEL%', readonly: !postId },
          { id: '측정시간', title: '측정시간', type: 'time', readonly: !postId },
          { id: '측정자', title: '측정자', type: 'text', placeholder: '', readonly: !postId },
          { id: '비고', title: '비고', type: 'text', placeholder: '', readonly: !postId },
        ]"
        :mobile="['물질명', '결과']"
        v-model="_item.subList"
        class="mt-28px"
      />

      <!-- 밀폐(제한)공간 작업  -->
      <table-custom
        v-if="_item.id === 5"
        :board="board"
        :is-print="isPrint"
        title="가스농도 측정결과(밀폐공간)"
        :controls="!!postId"
        :tableData="[
          { id: '물질명', title: '물질명 / 기준 / 결과', type: 'customType', width: isMobile ? '100px' : '800px', style: { padding: 0 }, readonly: !postId },
          { id: '측정시간', title: '측정시간', type: 'time', width: '100px', readonly: !postId },
          { id: '측정자', title: '측정자', type: 'text', placeholder: '', width: '100px', readonly: !postId },
          { id: '장소', title: '장소', type: 'text', placeholder: '', width: '150px', readonly: !postId },
          { id: '비고', title: '비고', type: 'text', placeholder: '', width: '100px', readonly: !postId },
          { id: '평가결과', title: '평가 결과', type: 'customType', placeholder: '', readonly: true, width: '100px', defaultValue: '부적합' },
        ]"
        :mobile="['물질명', '측정시간']"
        v-model="_item.subList"
        class="mt-28px"
      >
        <template #customType="{ trData, id, index, input, noteIndex }">
          <!-- 물질명 컬럼 -->
          <div v-if="id === '물질명' && trData" class="grid w-full grid-cols-1 md:grid-cols-2 xl:grid-cols-4">
            <!-- 산소 -->
            <div :class="isMobile ? '' : 'border-right'" style="align-content: center; justify-items: start; min-height: 50px; padding: 8px">
              <div class="mb-2">산소(O2) : 18%~23.5%</div>
              <div class="w-full flex">
                <p v-if="isPrint" class="print-input">{{ _item.subList[index].산소 }}</p>
                <ml-input v-else v-model="_item.subList[index].산소" class="w-full" :readonly="!postId" @input="updateEvaluationResult(_item, index)" />
                <span class="mx-2" style="align-content: center">%</span>
              </div>
            </div>
            <!-- 탄산가스 -->
            <div :class="isMobile ? '' : 'border-right'" style="align-content: center; justify-items: start; min-height: 50px; padding: 8px">
              <div class="mb-2">탄산가스(CO2) : 1.5% ↓</div>
              <div class="w-full flex">
                <p v-if="isPrint" class="print-input">{{ _item.subList[index].탄산가스 }}</p>
                <ml-input v-else v-model="_item.subList[index].탄산가스" class="w-full" :readonly="!postId" @input="updateEvaluationResult(_item, index)" />
                <span class="mx-2" style="align-content: center">%</span>
              </div>
            </div>
            <!-- 일산화탄소 -->
            <div :class="isMobile ? '' : 'border-right'" style="align-content: center; justify-items: start; min-height: 50px; padding: 8px">
              <div class="mb-2">일산화탄소(CO) : 30ppm ↓</div>
              <div class="w-full flex">
                <p v-if="isPrint" class="print-input">{{ _item.subList[index].일산화탄소 }}</p>
                <ml-input v-else v-model="_item.subList[index].일산화탄소" class="w-full" :readonly="!postId" @input="updateEvaluationResult(_item, index)" />
                <span class="mx-2" style="align-content: center">ppm </span>
              </div>
            </div>
            <!-- 황화수소 -->
            <div style="align-content: center; justify-items: start; min-height: 50px; padding: 8px">
              <div class="mb-2">황화수소(H2S) : 10ppm ↓</div>
              <div class="w-full flex">
                <p v-if="isPrint" class="print-input">{{ _item.subList[index].황화수소 }}</p>
                <ml-input v-else v-model="_item.subList[index].황화수소" class="w-full" :readonly="!postId" @input="updateEvaluationResult(_item, index)" />
                <span class="mx-2" style="align-content: center">ppm </span>
              </div>
            </div>
          </div>
          <!-- 평가결과 컬럼 -->
          <div v-else-if="id === '평가결과'" class="flex items-center justify-center gap-2">
            <template v-if="getEvaluationResult(trData) === '적합'">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#CAF9DF"/>
                <path d="M13.6436 5.95214C13.5413 5.85511 13.4039 5.80078 13.2607 5.80078C13.1175 5.80078 12.98 5.85511 12.8778 5.95214L7.95419 10.824L5.98471 8.8117C5.93769 8.75101 5.87776 8.7008 5.80895 8.66448C5.74013 8.62817 5.66408 8.60658 5.5859 8.6012C5.50772 8.59582 5.42921 8.60676 5.35578 8.63329C5.28235 8.65982 5.21567 8.70133 5.16024 8.75498C5.10482 8.80863 5.06197 8.87317 5.03456 8.94425C5.00716 9.01533 4.99582 9.09126 5.00137 9.16694C5.00693 9.24262 5.02924 9.31627 5.06675 9.38288C5.10427 9.44949 5.15617 9.50753 5.21888 9.55305L7.6259 11.989C7.6259 12.0949 7.84478 12.2008 7.95419 12.2008C8.03912 12.2008 8.12285 12.1816 8.19881 12.1449C8.27477 12.1081 8.34085 12.0547 8.39181 11.989L13.6436 6.69352C13.7438 6.59453 13.8 6.46144 13.8 6.32283C13.8 6.18422 13.7438 6.05113 13.6436 5.95214Z" fill="#28C76F"/>
              </svg>
              <span style="color: #28C76F; font-weight: 500;">적합</span>
            </template>
            <template v-else>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z" fill="#EA5455"/>
              </svg>
              <span style="color: #EA5455; font-weight: 500;">부적합</span>
            </template>
          </div>
        </template>
        <template #mobileTableColumns="{ mobileData, trData, value }">
          <div v-if="mobileData === '물질명'" class="flex flex-wrap justify-center">
            <span>{{ trData.산소 }}%,</span>
            <span> {{ trData.탄산가스 }}%,</span>
            <span> {{ trData.일산화탄소 }}ppm,</span>
            <span> {{ trData.황화수소 }}ppm</span>
          </div>
        </template>
      </table-custom>
      <p v-if="_item === '밀폐공간 작업'">※ 적정공기 : 산소(O2) 18% 이상 23.5% 미만, 탄산가스(CO2) 1.5% 미만, 일산화탄소(CO) 30ppm 미만, 황화수소(H2S) 10ppm 미만 / 그 외 가스 등은 관계법령 참조</p>
    </div>
  </div>
</template>

<script>
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  name: "WorkTable981",
  components: { TableCustom, TimeSelector, TableInspectMerge },
  props: {
    readonly: Boolean,
    isPrint: Boolean,
    board: Object,
    value: Array,
    status: Number,
  },
  computed: {
    list: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    isMobile() {
      return this.$viewport.isMobile;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
  },
  watch: {
    // 밀폐공간 작업의 가스농도 데이터가 변경될 때 평가결과 업데이트
    list: {
      deep: true,
      handler(newList) {
        if (!newList) return;

        // 밀폐공간 작업(id: 5) 찾기
        const 밀폐공간작업 = newList.find((item) => item.id === 5);
        if (!밀폐공간작업 || !밀폐공간작업.subList) return;

        // 각 행의 평가결과 업데이트
        밀폐공간작업.subList.forEach((row) => {
          if (row.산소 || row.탄산가스 || row.일산화탄소 || row.황화수소) {
            const result = this.getEvaluationResult(row);
            if (row.평가결과 !== result) {
              this.$set(row, "평가결과", result);
            }
          }
        });
      },
    },
  },
  methods: {
    handleChange() {
      const value = this.list.filter((item) => item.checked).map((item) => item.label);
      this.$emit("checkedTitle", value);
    },
    // 가스농도 측정값이 기준값을 만족하는지 평가
    getEvaluationResult(trData) {
      if (!trData) return "부적합";

      const 산소 = parseFloat(trData.산소);
      const 탄산가스 = parseFloat(trData.탄산가스);
      const 일산화탄소 = parseFloat(trData.일산화탄소);
      const 황화수소 = parseFloat(trData.황화수소);

      // 값이 유효하지 않으면 부적합
      if (isNaN(산소) || isNaN(탄산가스) || isNaN(일산화탄소) || isNaN(황화수소)) {
        return "부적합";
      }

      // 기준값 체크
      // 산소(O2): 18% 이상 23.5% 미만
      // 탄산가스(CO2): 1.5% 미만
      // 일산화탄소(CO): 30ppm 미만
      // 황화수소(H2S): 10ppm 미만
      const 산소적합 = 산소 >= 18 && 산소 < 23.5;
      const 탄산가스적합 = 탄산가스 < 1.5;
      const 일산화탄소적합 = 일산화탄소 < 30;
      const 황화수소적합 = 황화수소 < 10;

      if (산소적합 && 탄산가스적합 && 일산화탄소적합 && 황화수소적합) {
        return "적합";
      }

      return "부적합";
    },
    // 가스농도 값이 변경될 때 평가결과 업데이트
    updateEvaluationResult(item, index) {
      if (!item || !item.subList || !item.subList[index]) return;

      this.$nextTick(() => {
        const result = this.getEvaluationResult(item.subList[index]);
        this.$set(item.subList[index], "평가결과", result);
      });
    },
  },
};
</script>

<style scoped></style>
